import React from 'react';
import DOMPurify from 'dompurify';
import 'quill/dist/quill.snow.css'; // Importamos los estilos base de Quill

const RichTextReader = ({ content, className = "" }) => {
    // 1. Si no hay contenido, no mostramos nada
    if (!content) return null;

    // 2. Limpiamos el HTML para evitar XSS (Scripts maliciosos)
    const sanitizedHTML = DOMPurify.sanitize(content);

    return (
        <div className={`rich-text-reader-wrapper ${className}`}>
            {/* 3. Estilos Específicos para Tablas y visualización
                Estos deben coincidir con los que pusiste en el Editor para mantener consistencia.
            */}
            <style>
                {`
                    .rich-text-reader-wrapper .ql-editor {
                        padding: 0; /* Quitamos el padding por defecto del editor si molesta */
                        height: auto; /* Altura automática según el contenido */
                    }
                    
                    /* Estilos críticos para las TABLAS */
                    .rich-text-reader-wrapper table { 
                        border-collapse: collapse; 
                        width: 100%; 
                        margin: 10px 0;
                    }
                    .rich-text-reader-wrapper td, 
                    .rich-text-reader-wrapper th { 
                        border: 1px solid #ccc; 
                        padding: 8px; 
                        min-width: 50px; 
                    }
                    
                    /* Listas y otros elementos */
                    .rich-text-reader-wrapper ul, 
                    .rich-text-reader-wrapper ol {
                        padding-left: 1.5em;
                    }
                `}
            </style>

            {/* 4. Estructura Mágica de Quill:
                - 'ql-snow': Activa el tema (fuentes, colores base).
                - 'ql-editor': Aplica el formato (alineación, listas, indentación).
            */}
            <div className="ql-snow">
                <div 
                    className="ql-editor" 
                    dangerouslySetInnerHTML={{ __html: sanitizedHTML }} 
                />
            </div>
        </div>
    );
};

export default RichTextReader;